import type { BusInformation, BusStop } from '../../domain/types'
import type { BusInformationAPIResponse, BusStopAPIResponse } from '../types'

function mapBusStop(stop: BusStopAPIResponse | undefined, includePickupTime: boolean): BusStop | null {
  if (!stop) {
    return null
  }

  const departureDateTime = stop.departureDateTime ?? null

  return {
    city: stop.city ?? '',
    location: stop.location ?? '',
    departureDate: departureDateTime ?? '',
    arrivalDate: stop.arrivalDateTime ?? '',
    pickupTime: includePickupTime ? departureDateTime : null,
  }
}

export function busInformationMapper(apiResponse: BusInformationAPIResponse | undefined): BusInformation | null {
  if (!apiResponse) {
    return null
  }
  return {
    outbound: mapBusStop(apiResponse.outbound, true),
    inbound: mapBusStop(apiResponse.inbound, false),
  }
}
